// 项目信息化建设（移动端）
<template>
  <div class="cmain">
    <mheader></mheader>
    <div class="topimg"></div>
    <div class="center">
      <h1 class="title">项目信息化建设</h1>
      <p
        class="jianjie"
      >以工程项目为服务对象，通过云计算、大数据、物联网、人工智能、移动智能终端和5G等信息技术，为企业提供投标展示方案、图纸会审、工程量的统计、施工模拟、可视化交底、施工节点分析、综合管线碰撞检测、建筑物全生命周期信息化模型等BIM、智慧工地方面的咨询服务。</p>
      <div class="msg">
        <div class="leftMsg">
          <div class="one"></div>
          <div class="two"></div>
          <div class="three"></div>
          <div class="four"></div>
          <div class="five"></div>
        </div>
        <div class="rightMsg">
          <div class="msone">
            <h2>投标阶段信息化</h2>
            <p>利用BIM、计算机图形学与动画技术等信息技术，为客户提供投标项目的主要施工方案、关键施工部位可视化模拟方案，比较直观、形象地展示给建设单位，充分体现客户的施工经验和技术能力，助力客户赢得投标工程。</p>
          </div>
          <div class="mstwo">
            <h2>建造过程中信息化</h2>
            <p>利用BIM、4D技术、虚拟仿真技术、计算机图形学与动画技术、移动互联网、大数据等信息技术，对拟建工程的各分部分项工程、施工工序、机械设备、现场布置等随进度的变化进行动态虚拟模拟。针对各专业工程不协调、工作量不准确、施工进度变化、综合管线碰撞等问题，以及装配式部品部件的加工安装、信息化样板、可视化技术交底、质量安全绿色施工信息化管控、场地布置等方面提供咨询服务。</p>
          </div>
          <div class="msthree">
            <h2>运行维护阶段信息化</h2>
            <p>利用BIM、物联网、传感器等技术，采集建筑物建造过程中的历史数据，实现实物与信息模型同步，为后期运营维护提供真实、客观、有效的数据。</p>
          </div>
        </div>
      </div>
    </div>
    <mfooter></mfooter>
  </div>
</template>

<script>
import mheader from "../../components/mobileHF/mHeader";
import mfooter from "../../components/mobileHF/mFooter";
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {
    if (this.isMobile()) {
      this.$router.replace("/mInformation"); //移动端跳转路由
    } else {
      this.$router.replace("/information"); //Pc端跳转路由
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  components: {
    mheader,
    mfooter,
  },
};
</script>

<style scoped lang="less">
.cmain {
  .topimg {
    width: 100%;
    height: 8.9rem;
    background: url("../../assets/img/mobile/mBanner/信息化建设.png") 0 0
      no-repeat;
    background-size: 100%;
  }
  .center {
    width: 100%;
    padding: 0rem 0.6rem;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 1rem;
    .title {
      opacity: 1;
      font-size: 1rem;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      text-align: center;
      color: #4279db;
      line-height: 1.4rem;
      margin: 1rem 0rem;
    }
    .jianjie {
      opacity: 1;
      font-size: 0.75rem;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      // font-weight: bolder;
      line-height: 1.3rem;
      text-align: justifyLeft;
      color: #231815;
      text-indent: 2em;
    }
    .msg {
      margin: 1rem auto;
      .leftMsg {
        width: 3.5rem;
        height: 100%;
        float: left;
        .one {
          width: 3rem;
          height: 3rem;
          background: url("../../assets/img/信息化建设/组 37@2x.png") 0 0
            no-repeat;
          background-size: 100%;
          margin-bottom: 2.7rem;
        }
        .two {
          width: 2rem;
          height: 2.5rem;
          background: url("../../assets/img/信息化建设/矩形 4@2x.png") 0 0
            no-repeat;
          background-size: 100%;
          margin-left: 0.52rem;
          margin-bottom: 2.6rem;
        }
        .three {
          width: 3rem;
          height: 3rem;
          background: url("../../assets/img/信息化建设/组 37_1@2x.png") 0 0
            no-repeat;
          background-size: 100%;
          margin-bottom: 4.46rem;
        }
        .four {
          width: 2rem;
          height: 2.5rem;
          background: url("../../assets/img/信息化建设/矩形 4@2x.png") 0 0
            no-repeat;
          background-size: 100%;
          margin-left: 0.52rem;
          margin-bottom: 6rem;
        }
        .five {
          width: 3rem;
          height: 3rem;
          background: url("../../assets/img/信息化建设/-e-组37.png") 0 0
            no-repeat;
          background-size: 100%;
        }
      }
      .rightMsg {
        width: 13.8rem;
        height: 100%;
        float: right;
        .msone {
          width: 100%;
          height: 10.5rem;
          overflow: hidden;
          margin-bottom: 0.15rem;
        }
        .mstwo {
          width: 100%;
          height: 15rem;
          overflow: hidden;
          margin-bottom: 1.1rem;
        }
        .msthree {
          width: 100%;
          height: 10.5rem;
          overflow: hidden;
        }
      }
    }
  }
}
h2 {
  opacity: 1;
  font-size: 1rem;
  font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
  font-weight: 400;
  color: #1f89ec;
  margin: 0;
  margin-bottom: 1rem;
}
.rightMsg p {
  width: 100%;
  padding-bottom: 1rem;
  opacity: 1;
  font-size: 0.7rem;
  font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
  font-weight: 400;
  text-align: justifyLeft;
  color: #231815;
  line-height: 1.2rem;
  margin-bottom: 6rem;
}
</style>
